import * as AlertDialog from '@radix-ui/react-alert-dialog';
import noop from 'lodash/noop';
import { twMerge } from 'tailwind-merge';

import { Button } from '../Button';

interface LeavePromptProps {
  readonly open?: boolean;
  readonly title?: string;
  readonly description?: string;
  readonly onLeave?: (payload?: unknown) => void;
  readonly onClose?: () => void;
}

function LeavePrompt({
  open,
  title = 'Do you want to leave this page?',
  description = 'Changes you made may not be saved.',
  onLeave = noop,
  onClose,
}: LeavePromptProps) {
  const onLeaveClick = () => {
    onLeave();
    onClose?.();
  };

  return (
    <AlertDialog.Root open={open}>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="fixed inset-0 z-50 bg-black/60 transition-opacity" />
        <AlertDialog.Content
          className={twMerge(
            'fixed left-2/4 top-1/4 z-50 -mt-8 w-11/12 -translate-x-2/4 -translate-y-2/4 overflow-auto rounded-md bg-white font-serif shadow-md',
            'md:w-screen md:max-w-lg',
            'focus:outline-none',
          )}
        >
          <AlertDialog.Title className="m-0 bg-blue-400 p-4 font-medium text-white">Leaving Page</AlertDialog.Title>
          <AlertDialog.Description className="p-4 text-sm text-neutral-500">
            <span className="mb-1 font-medium">{title}</span>
            <span>{description}</span>
          </AlertDialog.Description>
          <div className="flex items-center justify-end space-x-2 border-t border-neutral-200 p-3.5">
            <Button variant="primary" onClick={onLeaveClick}>
              Leave
            </Button>
            <Button variant="secondary" onClick={onClose}>
              Stay
            </Button>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
}

export { LeavePrompt };
